import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useVideos(env, client) {
  const [loadedVideos, setLoadedVideos] = useState(false);
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    setLoadedVideos(false);
    if (!client) {
      setLoadedVideos(true);
      return () => [];
    }
    const ref = collection(db, "kiosk", env, "client", client, "videos");
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = {};
      snapshot.docs.forEach((doc) => {
        data[doc.id] = {
          id: doc.id,
          ...doc.data()
        };
      });
      setVideos(data);
      setLoadedVideos(true);
    });
    return () => unsub();
  }, [env, client]);

  return { loadedVideos, videos };
}